export default class StringUtils {
    constructor() {

    }

    trimWithLeaveTrailNewline(text) {
        return text.replace(/([^\S\n]+$)|^\s+/g, '');
    }
}